import type { MapMode, LayerVisibility } from '../../../types/mapEngine';

export const LAYER_PRESETS: Record<MapMode, LayerVisibility> = {
  'fts-conops': {
    'base-runways':             true,
    'base-aprons':              true,
    'base-taxiways':            true,
    'base-twy-labels':          true,
    'base-stands':              true,
    'base-stand-labels':        true,
    'base-agl-spots':           true,
    'conops-aor':               true,
    'conops-taxi-routes':       true,
    'conops-pushback-profiles': true,
    'conops-aptr':              true,
    'conops-roundabout':        true,
    'conops-handover-points':   true,
    'aircraft-silhouettes':     false,
    'aviplan-swept-paths':      false,
    'aviplan-safety-envelopes': false,
    'aviplan-jet-blast':        false,
  },

  'fts-simulation': {
    'base-runways':             true,
    'base-aprons':              true,
    'base-taxiways':            true,
    'base-twy-labels':          false,
    'base-stands':              true,
    'base-stand-labels':        true,
    'base-agl-spots':           true,
    'aircraft-silhouettes':     true,
    'conops-aor':               true,
    'conops-taxi-routes':       true,
    'conops-pushback-profiles': false,
    'conops-aptr':              true,
    'conops-roundabout':        false,
    'conops-handover-points':   true,
    'aviplan-swept-paths':      false,
    'aviplan-safety-envelopes': false,
    'aviplan-jet-blast':        false,
  },

  'analysis-infrastructure': {
    'base-runways':             true,
    'base-aprons':              true,
    'base-taxiways':            true,
    'base-twy-labels':          false,
    'base-stands':              true,
    'base-stand-labels':        false,
    'base-agl-spots':           false,
    'aircraft-silhouettes':     false,
    'conops-aor':               false,
    'conops-taxi-routes':       false,
    'conops-pushback-profiles': false,
    'conops-aptr':              false,
    'conops-roundabout':        false,
    'conops-handover-points':   false,
    'heatmap-congestion':       false,
    'heatmap-arrivals':         false,
    'heatmap-departures':       false,
    'heatmap-taxi-risk':        false,
    'heatmap-taxi-speed':       false,
    'heatmap-pushback-risk':    false,
    'heatmap-ci-graph':         false,
    'heatmap-tcf-graph':        false,
    'heatmap-mht-graph':        false,
    'aviplan-swept-paths':      false,
    'aviplan-safety-envelopes': false,
    'aviplan-jet-blast':        false,
  },

  'analysis-heatmap': {
    'base-runways':             true,
    'base-aprons':              true,
    'base-taxiways':            false,
    'base-twy-labels':          false,
    'base-stands':              true,
    'base-stand-labels':        false,
    'base-agl-spots':           false,
    'aircraft-silhouettes':     false,
    'conops-aor':               false,
    'conops-taxi-routes':       false,
    'conops-pushback-profiles': false,
    'conops-aptr':              false,
    'conops-roundabout':        false,
    'conops-handover-points':   false,
    'heatmap-congestion':       true,
    'heatmap-arrivals':         false,
    'heatmap-departures':       false,
    'heatmap-taxi-risk':        false,
    'heatmap-taxi-speed':       false,
    'heatmap-pushback-risk':    false,
    'heatmap-ci-graph':         false,
    'heatmap-tcf-graph':        false,
    'heatmap-mht-graph':        false,
    'aviplan-swept-paths':      false,
    'aviplan-safety-envelopes': false,
    'aviplan-jet-blast':        false,
  },

  'analysis-pushback': {
    'base-runways':             true,
    'base-aprons':              true,
    'base-taxiways':            true,
    'base-twy-labels':          false,
    'base-stands':              true,
    'base-stand-labels':        true,
    'base-agl-spots':           false,
    'aircraft-silhouettes':     false,
    'conops-aor':               false,
    'conops-taxi-routes':       false,
    'conops-pushback-profiles': true,
    'conops-aptr':              false,
    'conops-roundabout':        false,
    'conops-handover-points':   false,
    'heatmap-pushback-risk':    true,
    'heatmap-congestion':       false,
    'heatmap-arrivals':         false,
    'heatmap-departures':       false,
    'heatmap-taxi-risk':        false,
    'heatmap-taxi-speed':       false,
    'heatmap-ci-graph':         false,
    'heatmap-tcf-graph':        false,
    'heatmap-mht-graph':        false,
    'aviplan-swept-paths':      true,
    'aviplan-safety-envelopes': true,
    'aviplan-jet-blast':        false,
  },
};
